import React from "react";
import { useTranslation } from "react-multi-lang";
import { Provider, useSelector } from "react-redux";
import StoreHelper from "../../../../../services/store-helper";
import CalendarView from "./components/CalendarView";
import HolidayForm from "./components/HolidayForm";
import reducerSlice from "./redux/Reducer";

const HolidayDate = () => {
  const store = StoreHelper.generateStoreState(reducerSlice);
  const MainComponent = () => {
    const t = useTranslation();
    const showForm = useSelector((state) => state.reducer.showForm);
    store.getState();

    const Content = () => {
      if (!showForm) {
        //show calendar
        return <CalendarView />;
      } else {
        //show form
        return <HolidayForm />;
      }
    };

    return (
      <div className="px-2 pt-6">
        <div className="flex">
          <div className="w-60 mr-12">
            <div className="text-lg font-semibold">
              {t("holidaydate.subtitle")}
            </div>
            <div className="pt-3 text-green-tertiary">
              {t("holidaydate.description")}
            </div>
          </div>
          <div className="flex-1">
            <Content />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Provider store={store}>
      <MainComponent />
    </Provider>
  );
};

export default HolidayDate;
